import React from 'react';

type FicoScoreRangeProps = {
  className?: string;
  class?: string;
  scores: string[];
  features?: string[];
};
class FicoScoreRange extends React.Component<FicoScoreRangeProps> {
  scoresMap = [
    {
      id: 'poor',
      value: 'Poor',
      cl: 'bg-red rounded-start'
    },
    {
      id: 'fair',
      value: 'Fair',
      cl: 'bg-orange'
    },
    {
      id: 'good',
      value: 'Good',
      cl: 'bg-yellow'
    },
    {
      id: 'verygood',
      value: 'Very Good',
      cl: 'bg-green'
    },
    {
      id: 'excellent',
      value: 'Excellent',
      cl: 'bg-dark-green rounded-end'
    }
  ];

  render() {
    const classBasename = 'fico-score-range';
    const cl = this.props.class || this.props.className || '';
    const addon: string[] = [];
    const renderRange = () => {
      let creditRange: string[] = [];
      if (this.props?.scores?.length) {
        creditRange = this.props.scores.sort((a: any, b: any) => {
          const scoreID: any = {
            Poor: 4,
            Fair: 3,
            Good: 2,
            'Very Good': 1,
            Excellent: 0
          };
          if (scoreID[a] > scoreID[b]) {
            return -1;
          }
          return scoreID[a] < scoreID[b] ? 1 : 0;
        });
        creditRange = creditRange.map((item) => (item === 'Excellent' ? 'Exceptional' : item));
      }
      const formedRating = [];
      if (creditRange.length) {
        formedRating.push(creditRange[0]);
      }
      if (creditRange.length > 1) {
        formedRating.push(creditRange[creditRange.length - 1]);
      }
      if (this.props.features) {
        if (this.props.features.includes('New to Credit')) {
          addon.push('New to Credit');
        }
        if (this.props.features.includes('Rebuilding')) {
          addon.push('Rebuilding');
        }
      }
      return (
        formedRating.join(' - ') +
        (formedRating.length && addon.length ? ', ' : '') +
        (addon.length ? addon.join(', ') : '')
      );
    };

    const range = renderRange();
    return (
      <div className={`${classBasename} d-table ${cl}`}>
        {range && <p className="body-text-sm text-center mb-2">{range}</p>}
        <div className="d-flex align-items-center">
          {this.scoresMap.map((score) => (
            <span
              key={score.id}
              className={`${this.props.scores.includes(score.value) ? 'in-range' : ''} ${score.cl}`}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default FicoScoreRange;
